import { createContext } from 'react';

import type { AdminCurrentSession } from '@mds/shared/types/admin-auth';

export type SessionStatus = 'loading' | 'authenticated' | 'anonymous';

export interface SessionValue {
  status: SessionStatus;
  session: AdminCurrentSession | null;
  /** Re-reads /me. Called after a successful OTP verification. */
  refresh: () => Promise<void>;
  signOut: () => Promise<void>;
  /** True when the signed-in admin holds the permission key, e.g. 'content.manage'. */
  can: (permission: string) => boolean;
  /** True when they hold the role key, e.g. 'super_admin'. */
  is: (role: string) => boolean;
}

/**
 * Kept apart from the provider and the hook so each module exports one kind of
 * thing — otherwise fast refresh stops working for whichever file mixes them.
 */
export const SessionContext = createContext<SessionValue | null>(null);
